/*
 * Number 工具类
 *
 * Author: Patrick.ho
 * History:
 * Date      Version Remarks
 * ========= ======= ======================================================
 * 2016      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 */

/**
 * Implementation of toFixed() that treats floats more like decimals
 *
 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
 * problems for accounting- and finance-related software.
 *
 * @param value : [Number] 必填，原值
 * @param maxDecimals :  [Number] 必填，最多的小数位数
 * @param optionals : [Number] 末尾如果为0则可以移除的长度, 必须比maxDecimals少
 * @param roundingFunction : [Function] 舍去函数， 默认是 Math.round
 * @returns {string}
 *
 console.info(toFixed(123456789.987654, 4))             ====> 123456789.9877
 console.info(toFixed(123456789.98, 4))                 ====> 123456789.9800
 console.info(toFixed(123456789.987654, 2))             ====> 123456789.99

 console.info(toFixed(123456789.9876543212345, 7, 2))   ====> 123456789.9876543
 console.info(toFixed(123456789.9870000000000, 7, 2))   ====> 123456789.98700
 console.info(toFixed(123456789.9870000000000, 7, 3))   ====> 123456789.9870
 console.info(toFixed(123456789.9870000000000, 7, 4))   ====> 123456789.987
 console.info(toFixed(123456789.9876543212345, 7, 4))   ====> 123456789.9876543
 */
function toFixed (value=0, maxDecimals, optionals, roundingFunction) {
    if(value===null){
        return 0;
    }
    var splitValue = value.toString().split('.'),
        minDecimals = maxDecimals - (optionals || 0),
        _roundingFunction = (roundingFunction !== undefined) ? roundingFunction : Math.round,
        boundedPrecision,
        optionalsRegExp,
        power,
        output;


    // Use the smallest precision value possible to avoid errors from floating point representation
    if (splitValue.length === 2) {
        boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
    } else {
        boundedPrecision = minDecimals;
    }

    power = Math.pow(10, boundedPrecision);

    //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
    // Multiply up by precision, round accurately, then divide and use native toFixed():
    output = (_roundingFunction(value * power) / power).toFixed(boundedPrecision);

    if (optionals > maxDecimals - boundedPrecision) {
        optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
        output = output.replace(optionalsRegExp, '');
    }

    return output;
}

/**
 * 数字每隔三个数字加逗号
 * Get a number with commas as thousands separators
 * @param x
 * @returns {string}
 */
function numberWithCommas(x=0) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

/**
 * 去除千分位
 * 1,234.00 -> 1234.00
 */
function offNumberWithCommas(val) {
    if (val === '0' || val === 0) {
    } else if (!val) return;
    if (/^(\d*,?\d*)*\.?\d*$/g.test(val)) {
        val = typeof val === 'number' ? val.toString() : val;
        val = Number(val.replace(/,/g, ''));
    }
    return val;
}

/**
 * toFixed + 格式化
 * @param value  : 必填
 * @param maxDecimals : 必填
 * @param optionals
 * @param roundingFunction
 * @returns {string}
 *
 console.info(toFixedWithCommas(123456789.987654321, 2));           ====> 123,456,789.99
 console.info(toFixedWithCommas(123456789.987654321, 3));           ====> 123,456,789.988
 console.info(toFixedWithCommas(123456789.987654321, 4));           ====> 123,456,789.9877

 console.info(toFixedWithCommas(123456789.9870000000000, 7, 2));    ====> 123,456,789.98700
 console.info(toFixedWithCommas(123456789.9870000000000, 7, 3));    ====> 123,456,789.9870
 console.info(toFixedWithCommas(123456789.9870000000000, 7, 4));    ====> 123,456,789.987
 console.info(toFixedWithCommas(123456789.9876543212345, 7, 4));    ====> 123,456,789.9876543

 */
function toFixedWithCommas (value, maxDecimals, optionals, roundingFunction){
    var x = numberWithCommas(toFixed(value, maxDecimals, optionals, roundingFunction));
    return x;
}

/**
 * 精确相加
 */
function floatAdd(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
}
/**
 * 精确相乘
 */
function floatMul(arg1, arg2) {
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length
    } catch (e) {
    }
    try {
        m += s2.split(".")[1].length
    } catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
/**
 * 精确相减
 */
function floatSub(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
}
/**
 * 精确相除
 */
function floatDiv(arg1, arg2) {
    var t1 = 0, t2 = 0, r1, r2;
    try {
        t1 = arg1.toString().split(".")[1].length
    } catch (e) {
    }
    try {
        t2 = arg2.toString().split(".")[1].length
    } catch (e) {
    }

    r1 = Number(arg1.toString().replace(".", ""));

    r2 = Number(arg2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
}

module.exports = {
    toFixed : toFixed,
    numberWithCommas : numberWithCommas,
    offNumberWithCommas: offNumberWithCommas,
    toFixedWithCommas : toFixedWithCommas,
    floatAdd: floatAdd,
    floatMul: floatMul,
    floatSub: floatSub,
    floatDiv: floatDiv,
};


